<h2 class="nomargin">Preview rental agreement</h2>
<span class="subheading">See how this message will look in a real-life reservation</span>

<mat-spinner *ngIf="loading" [diameter]="16"></mat-spinner>

<ng-container *ngIf="!loading">
  <mat-form-field class="fw" *ngIf="reservations && reservations.length > 0">
    <mat-label>Reservation</mat-label>
    <mat-select
      placeholder="Select a reservation"
      (openedChange)="onDropdownOpened($event)"
      [(ngModel)]="reservationUUID"
      (selectionChange)="reservationChanged($event)">
      <div class="search-container">
        <input
          matInput
          placeholder="Search reservation code or guest name"
          #searchInput
          [(ngModel)]="reservationCodeSearch"
          (ngModelChange)="filterReservations()"
          (click)="$event.stopPropagation()"
          (mousedown)="$event.stopPropagation()" />
      </div>

      <mat-option *ngFor="let reservation of filteredReservations" [value]="reservation.uuid">
        <div fxLayoutAlign="start center" fxLayoutGap="8px">
          <span>{{ reservation.guest }} ({{ reservation.code }})</span>
        </div>
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-spinner *ngIf="loadingPreview" [diameter]="16"></mat-spinner>

  <sbnb-alert-card context="negative" *ngIf="previewError">
    {{ previewError }}
  </sbnb-alert-card>
  <div *ngIf="!previewError" class="text-justify mb-8 p-6 border border-alt-gray">
    <p *ngIf="content && !loadingPreview" [innerHTML]="content | safe: 'html'"></p>

    <div *ngIf="content && activeReservation" class="max-w-md">
      <div class="pt-4 space-y-6">
        <div class="flex flex-col">
          <span class="text-lg font-semibold pb-2 border-b-2 border-alt-gray">{{ activeReservation?.guest }}</span>
          <span class="mt-1 text-sm text-gray-600">Name</span>
        </div>

        <div class="flex flex-col">
          <span class="text-lg font-semibold pb-2 border-b-2 border-alt-gray">
            <span class="cursor-pointer text-red-dark bg-red-light border border-dashed p-4 w-full block">
              Click to sign
            </span>
          </span>
          <span class="mt-1 text-sm text-gray-600">Signature</span>
        </div>

        <div class="flex flex-col">
          <span class="text-lg font-semibold pb-2 border-b-2 border-alt-gray">
            <ng-container *ngIf="activeReservation">
              {{ activeReservation.checkin | date: 'mediumDate' }}
            </ng-container>
          </span>
          <span class="mt-1 text-sm text-gray-600">Date</span>
        </div>
      </div>
    </div>
  </div>
</ng-container>
